module.exports = __webpack_public_path__ + "static/img/mo.250860a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/mo.jpg
// module id = sufx
// module chunks = 0